import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {translate} from 'react-i18next';
import classNames from 'classnames';
import ProductDetailView from '../Product/ProductDetailView';
import PropTypes from 'prop-types';
import * as _ from 'lodash';
import {getSizeOfPizza} from '../../helpers';

class DealCompositionView extends Component {
  constructor(props) {
    super(props);
    this.toggleComposition = this.toggleComposition.bind(this);
    this.isProductSelected = this.isProductSelected.bind(this);
    this.displayProduct = this.displayProduct.bind(this);
    this.removeDisplayedProduct = this.removeDisplayedProduct.bind(this);
    this.compositionPizzas = this.compositionPizzas.bind(this);
    this.compositionProducts = this.compositionProducts.bind(this);
    this.getSelectedProduct = this.getSelectedProduct.bind(this);
    this.addToCard = this.addToCard.bind(this);

    this.state = {
      displayedProduct: {},
    };
  }

  toggleComposition(id) {
    if (!this.props.isSelected) {
      this.props.onSelect(id);
    } else {
      this.props.onClose();
    }
  }

  isProductSelected(id, type) {
    const {displayedProduct} = this.state;
    return displayedProduct.type === type && displayedProduct.id === id;
  }

  displayProduct(id, type) {
    const selectedProduct = {id: id, type: type};
    this.setState({displayedProduct: selectedProduct});
  }

  removeDisplayedProduct() {
    this.setState({displayedProduct: {}});
  }

  compositionPizzas() {
    const {composition, restaurant} = this.props;
    return restaurant.pizzas.filter(pizza => {
       return _.includes(composition.pizzas, pizza.id) && getSizeOfPizza(pizza, null, [composition.size], composition.crusts).length > 0;
    });
  }

  compositionProducts() {
    const {composition, restaurant} = this.props;
    const result = [];
    _.map(composition.variants, (variant) => {
      const product = _.find(restaurant.products, {id: variant.product});
      if (!!product) {
        const option = _.find(product.options, {id: variant.option});
        if (!!option) {
          result.push({
            product: product,
            options: [option.id],
          });
        }
      }

    });
    return result;
  }

  getSelectedProduct() {
    const {selectedProduct, language, t} = this.props;
    let result = {};
    if (!selectedProduct) {
      return t('make_your_selection');
    }
    if (selectedProduct.type  === 'pizza') {
      result = _.find(this.compositionPizzas(), {id: selectedProduct.productId});
    } else if (selectedProduct.type === 'product') {
      const variant = _.find(this.compositionProducts(),
        variant => variant.product.id === selectedProduct.productId);
      if (!!variant) {
        result = variant.product;
      }
    }
    return result[`name_${language}`];
  }

  addToCard(data) {
    const {composition} = this.props;
    this.props.addToCard(composition, data);
    this.props.onClose();
  }

  render() {
    const {composition, t, language, isSelected, selectedProduct, restaurant} = this.props;
    return (
      <div
        className={classNames('deals-item', {
          'deals-item--expanded': isSelected,
        })}
      >
        <div
          className="deals-item__top"
          onClick={() => this.toggleComposition(composition.id)}
        >
          {isSelected &&
            <button className="deals-item__back-link">{t('back')}</button>
          }
          <div className="deals-item__text">
            <div className="deals-item__name">{composition[`name_${language}`]}</div>
            <div className="deals-item__info">{this.getSelectedProduct()}</div>
          </div>
          {!selectedProduct || isSelected ?
            <button className="deals-item__button" type='button'>
            </button>
            :
            <Link replace className="deals-item__link" to="#">{t('customize')}</Link>
          }
        </div>
        <div className="deals-item__content">
          <div className="deals-item__content-inner">
            <div className="deals-item__products">
              {composition.type === 'DealCompositionPizzas' &&
              this.compositionPizzas().map((pizza, index) => (
                <ProductDetailView
                  key={index}
                  type='pizza'
                  language={language}
                  product={pizza}
                  sizes={[composition.size]}
                  crusts={composition.crusts}
                  isSelected={this.isProductSelected(pizza.id, 'pizza')}
                  addToCard={this.addToCard}
                  onMouseEnter={() => this.displayProduct(pizza.id, 'pizza')}
                  onMouseLeave={this.removeDisplayedProduct}
                  restaurant={restaurant}
                />
              ))}
              {composition.type === 'DealCompositionProducts' &&
              this.compositionProducts().map((variant, index) => (
                <ProductDetailView
                  key={index}
                  type='product'
                  language={language}
                  product={variant.product}
                  options={variant.options}
                  isSelected={this.isProductSelected(variant.product.id, 'product')}
                  onMouseEnter={() => this.displayProduct(variant.product.id, 'product')}
                  onMouseLeave={this.removeDisplayedProduct}
                  addToCard={this.addToCard}
                  restaurant={restaurant}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DealCompositionView.propTypes = {
  composition: PropTypes.object,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  onClose: PropTypes.func,
  language: PropTypes.string,
  restaurant: PropTypes.object,
  selectedProduct: PropTypes.object,
  addToCard: PropTypes.func,
};

export default translate('translations')(DealCompositionView);


// WEBPACK FOOTER //
// ./src/components/Deals/DealCompositionView.js